import Record from './Record'

export default class Transaction extends Record {

	constructor (data) {
		super(data)

		return this._proxy
	}

	static async fetch (uuid = null) {
		if (uuid == null) {

			// Create record
			return new Transaction({
				uuid: await Anvil.REST.get('/util/uuid'),
				transaction_uid: null,
				manual_entry: 1,
				type: 'KÉSZPÉNZ BEFIZETÉS',
				direction: 'income',
				amount: 0,
				transaction_d: Anvil.moment().format('YYYY-MM-DD'),
				complete_d: Anvil.moment().format('YYYY-MM-DD'),
				sender: null,
				receiver: null,
				ban: '',
				swift: null,
				remark: null,
				signed_by: Anvil.session.user.id,
				company_id: null,
				note: null,
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/transaction/${uuid}`)
			return new Transaction(data)
		}
	}

	static async delete (uuid) {
		return await Anvil.REST.delete(`/transaction/${uuid}`)
	}

	async commit () {

		if (this._data.manual_entry == 1) {
			// Validate the record
			if (!this.validate()) {
				return false
			}
		}

		if (this._data.uuid == null) {
			// Insert
			const res = await Anvil.REST.post(`/transaction`, this._data)
			this._data.uuid = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/transaction/${this._data.uuid}`, this._data)
		}
	}

	validation_schema = {
		company_id: [
			'required'
		],
	}
}
